var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.imgTag)?_c('el-image',{staticClass:"media__image",attrs:{"src":_vm.imageToDisplay,"alt":"","fit":_vm.fit,"lazy":_vm.lazy}}):_c('img',{staticClass:"media__image",attrs:{"src":_vm.imageToDisplay,"alt":""}})}
var staticRenderFns = []

export { render, staticRenderFns }